import { apiFetch } from './apiClient';

export interface Item {
  product_id: number;
  prod_title: string;
  category: string;
  brand: string;
  sku: string;
  price?: number | string | null;
}

export interface ItemUpdatePayload {
  prod_title: string;
  category: string;
  brand: string;
  sku: string;
}

export interface ItemCreatePayload extends ItemUpdatePayload {
  product_id: number;
}

export interface ProductOpt {
  product_id: number;
  prod_title: string;
}

export const itemsService = (token: string | null) => ({
  list: (page: number, search?: string) => {
    const qs = new URLSearchParams({ page: String(page) });
    if (search) qs.set('search', search);
    return apiFetch<{ items: Item[]; total: number }>(token, `/api/items?${qs.toString()}`);
  },
  categories: () => apiFetch<{ categories: string[] }>(token, '/api/products/categories'),
  brands: () => apiFetch<{ brands: string[] }>(token, '/api/products/brands'),
  listOptions: (limit = 100, search?: string) => {
    const qs = new URLSearchParams();
    qs.set('limit', String(limit));
    if (search) qs.set('search', search);
    return apiFetch<{ items: ProductOpt[] }>(token, `/api/items?${qs.toString()}`);
  },
  update: (id: number, payload: ItemUpdatePayload) =>
    apiFetch(token, `/api/items/${id}`, { method: 'PUT', body: JSON.stringify(payload) }),
  create: (payload: ItemCreatePayload) =>
    apiFetch(token, '/api/items', { method: 'POST', body: JSON.stringify(payload) }),
  remove: (id: number) =>
    apiFetch(token, `/api/items/${id}`, { method: 'DELETE' }),
});
